var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "mode",
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "custom-class": "layout-dialog",
        title: "商品選択",
        top: "5vh",
        width: "900px",
        "show-close": false,
        visible: _vm.dialogVisible,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        opened: _vm.opened,
        close: _vm.close,
      },
    },
    [
      _c(
        "vab-query-form-mode",
        {
          staticClass: "dpform noborder",
          attrs: {
            model: _vm.queryForm,
            rules: _vm.rules,
            "enable-query-save": false,
            size: "mini",
            "label-position": "left",
            "label-width": "140px",
          },
          on: { search: _vm.onSearch },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("vab-input", {
                    attrs: {
                      label: "商品CD",
                      "label-width": "100px",
                      prop: "itmcd",
                      maxlength: "4",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("vab-input", {
                    attrs: {
                      label: "商品名(半角ｶﾅ)",
                      prop: "itmnmk",
                      maxlength: "50",
                      validate: "halfKana",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("vab-checkbox-group", {
                    ref: "jtwrkkb",
                    attrs: {
                      "label-width": "100px",
                      label: "受託作業区分",
                      filter: "entrustedWorkFlag",
                      prop: "jtwrkkbList",
                      disabled: _vm.localDisabled,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "m20" },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("vab-table", {
                ref: "table",
                attrs: {
                  "api-url": "/api/mitmbasp/query",
                  columns: _vm.columns,
                  "custom-config": false,
                  "multi-select": _vm.multiSelect,
                  height: "350",
                  "init-params": _vm.queryForm,
                  "query-params": _vm.queryForm,
                  "row-key": _vm.getRowKey,
                  "enable-init": false,
                },
                on: {
                  "update:queryParams": function ($event) {
                    _vm.queryForm = $event
                  },
                  "update:query-params": function ($event) {
                    _vm.queryForm = $event
                  },
                  "selection-change": _vm.setSelectRows,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer flex_end",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "flex_start flex_center_align" },
            [
              _c(
                "el-button",
                { staticClass: "cancel", on: { click: _vm.close } },
                [_vm._v("キャンセル")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v("確定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }